import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { BILLING_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { WebExpensePage } from '@/features/billing/pages/WebExpensePage';

export const Route = createFileRoute('/_auth/billing/web-expense')({
  beforeLoad: () => requirePermission(BILLING_PERMISSIONS.WEB_EXPENSES_CREATE),
  component: () => (
    <ErrorBoundary moduleName="Web Expense Info">
      <Suspense fallback={<PageLoader />}>
        <WebExpensePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
